var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCattle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 26,
    viewBox: "0 0 46 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9999 7.99975V21.0009H7.99972L11.9996 16.9994H13.9995L14.9995 22.0008V25.0007L17.9994 16.9994H20.9993V25.0007L24.9991 16.9994H32.9988V25.0007L36.0003 17.9994H38.0002L43.0001 25.0007V15.9995L41.0001 13.9995V3.99989L45 2.99993H41.0001L40.0002 1.99996L38.0002 1H15.9994L7.99972 8.99972H0",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9999 7.99975V21.0009H7.99972L11.9996 16.9994H13.9995L14.9995 22.0008V25.0007L17.9994 16.9994H20.9993V25.0007L24.9991 16.9994H32.9988V25.0007L36.0003 17.9994H38.0002L43.0001 25.0007V15.9995L41.0001 13.9995V3.99989L45 2.99993M45 2.99993V10.9996M45 2.99993H41.0001L40.0002 1.99996L38.0002 1H15.9994L7.99972 8.99972H0",
    stroke: "#0C2128",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCattle);
export default __webpack_public_path__ + "static/media/iconCattle.6f00c03bee7c57ad4f6c3e71048413af.svg";
export { ForwardRef as ReactComponent };